import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { CircularProgress, IconButton } from "@mui/material";
import React from "react";

/** Green circular play control on library cards (≥44pt). */
export default function LibraryPlayIconButton({
    onClick,
    disabled = false,
    loading = false,
    ariaLabel = "Play puzzle",
}) {
    return (
        <IconButton
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            aria-label={ariaLabel}
            sx={{
                width: 44,
                height: 44,
                minWidth: 44,
                minHeight: 44,
                flexShrink: 0,
                borderRadius: "50%",
                p: 0,
                color: "#ffffff",
                bgcolor: "#3BA666",
                boxShadow: "0 4px 12px rgba(59, 166, 102, 0.4)",
                "&:hover": {
                    bgcolor: "#2e7d32",
                },
                "&:active:not(.Mui-disabled)": {
                    transform: "scale(0.94)",
                },
                "&.Mui-disabled": {
                    bgcolor: "rgba(59, 166, 102, 0.35)",
                    color: "rgba(255, 255, 255, 0.85)",
                },
            }}
        >
            {loading ? (
                <CircularProgress size={22} sx={{ color: "#ffffff" }} />
            ) : (
                <PlayArrowRoundedIcon sx={{ fontSize: 26 }} />
            )}
        </IconButton>
    );
}
